module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-15.651799d7.png";